import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { CrudForm, TextField, useEntityManager, DatePicker } from 'elentari'
import metasAnalistaRepository from './MetasAnalistaRepository'

const validate = data => {
  return {
    metaSolicitacoes: data.metaSolicitacoes ? undefined : 'Obrigatório',
    data: data.data ? undefined : 'Data Inválida'
  }
}

const MetasAnalistaForm = props => {
  const entityManager = useEntityManager({
    repository: metasAnalistaRepository,
    handleError: data => data.message
  })

  const handleSubmit = data => {
    const analistaId = parseInt(props.match.params.id)
    return entityManager.onSubmit({
      ...data,
      analistaId,
      metaSolicitacoes: parseInt(data.metaSolicitacoes)
    })
  }
  return (
    <CrudForm
      {...props}
      {...entityManager}
      onSubmit={handleSubmit}
      validate={validate}
      withPaper
    >
      <Grid container spacing={2}>
        <Grid item sm={6} xs={12}>
          <Field
            fullWidth
            label="Meta de solicitações"
            name="metaSolicitacoes"
            type="number"
            parse={number => Math.abs(parseInt(number))}
            component={TextField}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Field fullWidth component={DatePicker} label="Data" name="data" />
        </Grid>
      </Grid>
    </CrudForm>
  )
}

export default MetasAnalistaForm
